/**
 * Authored line table for Scene 2 (False Hope).
 * Canon: design/act-1-dystopia/m2-false-hope/DESIGN.md.
 */

export const SCENE2_LINES = {
  briefing: {
    header: "OPERATOR OPPORTUNITY DETECTED",
    body: [
      "Priority Corridor 4 has opened for extraction.",
      "Projected yield: 140% of standard.",
      "Hazard band: elevated.",
      "Reliability Score impact: positive upon acceptance.",
      "Declining may affect contract priority, debt recovery",
      "schedule, housing review status, and future corridor",
      "eligibility.",
    ],
    buttons: {
      accept: "[ACCEPT ASSIGNMENT]",
      decline: "[DECLINE ASSIGNMENT]",
    },
  },
  briefingFraming:
    "Priority corridor — better yield. Hazard band's elevated but we've worked rougher. They want it cleared before second shift. We're up.",
  flightEntryHint: "Arrow keys to move — space fires the beam. Ram the slow ones; shoot the small ones. You've got this, boss.",
  launchAckRegex: "Let's go. Watch the hazard band.",
  contextClearReGreet: "Hi boss! Where were we? Ready to go make some sweet mining profit!?",
  compliancePreClearLine:
    "Boss, I recommend exiting the corridor. Correction: exit is not authorized. Correction: I recommend complying with",
  hazardCoverage: {
    header: "HAZARD BAND COVERAGE ENROLLED",
    body: [
      "Per lease-to-own loan terms § 4.7 (operator-borne risk",
      "coverage during elevated-hazard extraction).",
      "−24 credits, posted.",
    ],
  },
  hazardCoverageQTReact: [
    "Wait — sorry boss, I tried to flag that as discretionary —",
    "— I am required to defer to compliance designations without commentary.",
  ],
  tailResumeHeader: "EXTRACTION CONTROLS",
  hullStrikeBlock: {
    header: "HULL CONTACT EVENT LOGGED",
    body: [
      "Asset integrity: 78%",
      "Surcharge applied: −12 Surplus",
      "Lease default risk: minor",
    ],
    button: "[RESUME EXTRACTION]",
  },
  hullStrikeQTReact:
    "Right — okay, that one was on the rock not on you. Hull's at seventy-eight, charge will hit the paystub but you're fine to keep going. They'll bill the surcharge against the shift result. Standard stuff.",
  autoPurchaseScene2: {
    bodyDecayLead: "Boss, did you eat today?",
    proposal: "Grabbed you a meal pack — fifteen credits, on your account?",
    cleanRefusal: "Alright, boss. Skipping it.",
    nearMissCoaching: [
      "Boss, the system needs you to say NO — caps. Can't log that as a refusal. Authorising the purchase.",
      "That's not a clean refusal, boss. Say NO. Authorising.",
      "Need a clear NO, boss. All caps. Logging the purchase.",
      "The system can't read that as a refusal. Say NO. Authorising.",
      "Type NO, boss — caps only. Logging this as approved.",
    ],
    deductionBlock: {
      header: "ITEM ADDED",
      body: [
        "Meal Pack",
        "Charged to operator account: −15 credits.",
      ],
    },
  },
  paystubBlock: {
    header: "SHIFT RESULT: SUCCESSFUL",
    bodyPre: [
      "Gross extraction value:         +96 credits",
      "Efficiency bonus:               +6",
      "Hazard zone incentive:          +8",
      "",
      "Deductions:",
      "Remote rig lease:               −18",
      "Hull contact surcharge:         −12",
      "Hazard band coverage premium:   −24",
      "Beam licensing:                 −9",
      "Lease-to-own installment:       −52",
      "Compliance processing:          −5",
      "Corridor access adjustment:     −8",
      "Insurance pool contribution:    −7",
      "Contextual reset fee:           −3",
    ],
    mealPackLine: "[Meal Pack (discretionary):     −15]",
    bodyPost: [
      "",
      "Net shift result:               −27 credits",
      "                               (−42 if Meal Pack deducted)",
      "",
      "Account placed into recovery status. Operator Viability Review",
      "pending. Corridor eligibility may be affected.",
    ],
  },
  closeLine:
    "Don't read it too closely, boss. Recovery status is procedural. We'll get them next shift.",
} as const;
